import React from 'react';

const ProgressIndicator = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Dettagli Richiesta' },
    { number: 2, label: 'Conferma' },
    { number: 3, label: 'Pagamento' }
  ];

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.number}>
            <div className="flex flex-col items-center">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold ${
                  step?.number <= currentStep
                    ? 'bg-blue-600 text-white' :'bg-gray-200 text-gray-500'
                }`}
              >
                {step?.number}
              </div>
              <span
                className={`mt-2 text-xs sm:text-sm font-medium ${
                  step?.number <= currentStep ? 'text-blue-600' : 'text-gray-500'
                }`}
              >
                {step?.label}
              </span>
            </div>
            {index < steps?.length - 1 && (
              <div
                className={`flex-1 h-1 mx-2 ${
                  step?.number < currentStep ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;